module.exports = __webpack_public_path__ + "img/single-folded-content.c0516473.svg";